import React from 'react';

export const EDIT_STATUS_OPTIONS = [
  { value: 'pending',             label: 'New (Pending)',             icon: '🆕', color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
  { value: 'preorder',            label: 'Incomplete (PreOrder)',     icon: '⏳', color: '#4f46e5', bg: '#eef2ff', border: '#c7d2fe' },
  { value: 'no_response',         label: 'No Response',               icon: '📞', color: '#d97706', bg: '#fef9ee', border: '#fde68a' },
  { value: 'processing',          label: 'Confirmed (Processing)',    icon: '✅', color: '#0d9488', bg: '#f0fdfb', border: '#99f6e4' },
  { value: 'shipped',             label: 'Shipped',                   icon: '🚚', color: '#0284c7', bg: '#e0f2fe', border: '#7dd3fc' },
  { value: 'in_querier',          label: 'In Querier',                icon: '🛵', color: '#0284c7', bg: '#e0f2fe', border: '#7dd3fc' },
  { value: 'partially_delivered', label: 'Partially Delivered',       icon: '📦', color: '#ea580c', bg: '#ffedd5', border: '#fed7aa' },
  { value: 'delivered',           label: 'Delivered',                 icon: '🎉', color: '#16a34a', bg: '#dcfce7', border: '#86efac' },
];

export const TRAFFIC_PLATFORM_OPTIONS = [
  { value: 'manual',    label: 'Manual (Phone / Call)', icon: '📞', color: '#c2410c', bg: '#fff7ed', border: '#fed7aa' },
  { value: 'facebook',  label: 'Facebook (Page / Ads)', icon: '🟦', color: '#1d4ed8', bg: '#eff6ff', border: '#bfdbfe' },
  { value: 'tiktok',    label: 'TikTok (Ads / Page)',   icon: '🎵', color: '#be185d', bg: '#fdf2f8', border: '#fbcfe8' },
  { value: 'whatsapp',  label: 'WhatsApp',              icon: '💬', color: '#15803d', bg: '#dcfce7', border: '#86efac' },
  { value: 'google',    label: 'Google Ads / Search',   icon: '🔍', color: '#a16207', bg: '#fefce8', border: '#fde047' },
  { value: 'organic',   label: 'Direct / Website',      icon: '🌐', color: '#475569', bg: '#f1f5f9', border: '#cbd5e1' },
];

export const printPackingSlipHtml = (content: HTMLElement, orderNumber?: string) => {
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  if (!printWindow) return;
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Packing Slip - ${orderNumber || 'Order'}</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Inter', Arial, sans-serif; font-size: 12px; color: #1e293b; background: white; }
        .slip { width: 100%; max-width: 780px; margin: 0 auto; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f1f5f9; font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; color: #475569; }
        th, td { padding: 8px 12px; }
        .slip-header { background: linear-gradient(135deg, #0f172a, #1e293b); color: white; padding: 16px 20px; display: flex; justify-content: space-between; align-items: center; }
        .slip-header .store-name { font-size: 16px; font-weight: 800; color: #f8fafc; }
        .slip-header .store-phone { font-size: 11px; color: #94a3b8; margin-top: 2px; }
        .slip-header .courier-label { font-size: 9px; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.1em; text-align: right; }
        .slip-header .courier-name { font-size: 14px; font-weight: 800; color: #f8fafc; text-align: right; margin-top: 2px; }
        .info-row { display: flex; border-bottom: 1px solid #e2e8f0; }
        .ship-to { flex: 1; padding: 14px 18px; border-right: 1px solid #e2e8f0; }
        .order-info { width: 220px; padding: 14px 18px; background: #f8fafc; }
        .section-label { font-size: 9px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px; }
        .recipient-name { font-size: 15px; font-weight: 800; color: #0f172a; margin-bottom: 4px; }
        .info-table td { padding: 3px 0; font-size: 11px; }
        .info-table .key { color: #64748b; font-weight: 600; padding-right: 10px; white-space: nowrap; }
        .info-table .val { font-weight: 700; color: #1e293b; }
        .items-table thead tr { border-bottom: 2px solid #e2e8f0; }
        .items-table tbody tr { border-bottom: 1px solid #f1f5f9; }
        .items-table tbody tr:nth-child(even) { background: #f8fafc; }
        .totals-wrap { display: flex; justify-content: flex-end; border-top: 1px solid #e2e8f0; }
        .totals-table { width: 260px; }
        .totals-table td { padding: 7px 14px; font-size: 12px; }
        .totals-table .lbl { color: #64748b; }
        .cod-row td { background: linear-gradient(135deg, #0f172a, #1e293b) !important; color: white !important; font-weight: 800; font-size: 14px; padding: 11px 14px; }
        .slip-footer { padding: 10px 18px; background: #f8fafc; border-top: 1px solid #e2e8f0; font-size: 10px; color: #94a3b8; text-align: center; }
        @page { margin: 10mm; size: A4; }
        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
      </style>
    </head>
    <body>
      <div class="slip">${content.outerHTML}</div>
    </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => { printWindow.print(); printWindow.close(); }, 400);
};
